import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createActionGroup, createFeature, createReducer, createSelector, on, props } from '@ngrx/store';
import { DrillBankInterface } from '../../drill-bank/drill-bank.interface';

export const NAME = 'drillBanks';

export type State = EntityState<DrillBankInterface>;

export const adapter: EntityAdapter<DrillBankInterface> = createEntityAdapter<DrillBankInterface>();

export const initialState: State = adapter.getInitialState();

export const actions = createActionGroup({
  source: 'DrillBanks',
  events: {
    'Upsert Drill Banks': props<{ drillBanks: DrillBankInterface[] }>(),
  },
});

export const feature = createFeature({
  name: NAME,
  reducer: createReducer(
    initialState,
    on(actions.upsertDrillBanks, (state, { drillBanks }): State => adapter.upsertMany(drillBanks, state))
  ),
});

/**
 * Null-safe name lookup: returns an empty string while the drill bank
 * is not (yet) in the store, so route data (breadcrumbs) can't crash on it.
 *
 * Standalone props-selector: `createFeature`'s `extraSelectors` only accepts
 * single-argument selectors or selector factories.
 */
export const selectName = createSelector(
  feature.selectEntities,
  (entities, byId: { id: number }): string => entities[byId.id]?.name ?? ''
);
